<template>
	<div class="shareppl-parentdiv d-flex">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="quesbankmain-container">
			<div
				class="headtext d-flex align-items-center justify-content-between position-relative"
			>
				<div class="heading">
					<span>{{ pageTitle }}</span>
				</div>

				<div
					v-if="
						selectedGroupDel.length > 0 && selectedDataType == candidateType
					"
					class="pl-3 pr-3 pt-1 pb-1 qb-sel-questions grp-top-selected-pos mr-2 d-flex align-items-center"
				>
					Selected {{ pageTitle }} : {{ selectedGroupDel.length }}
				</div>
			</div>
			<!-- here -->
			<div class="d-flex align-items-center">
				<div
					id="top1"
					class="relativeclass mt-3 group-slectedcandidate-table-container"
				>
					<!-- table starts -->
					<div class="d-flex align-items-end justify-content-between">
						<div class="d-flex align-items-center mb-0">
							<div
								v-if="roles.includes('GET_INDIVIDUAL')"
								class="position-relative d-flex align-items-center grp-mr pointer"
								@click="switchTabs('I')"
							>
								<div
									:class="candidateType === 'I' ? 'grp-tab-sel' : 'grp-tab'"
									class="d-flex align-items-center justify-content-center"
								>
									Individuals
								</div>
								<div
									:class="candidateType === 'I' ? 'grp-slant-sel' : 'grp-slant'"
								></div>
							</div>
							<div
								v-if="roles.includes('GET_GROUP')"
								@click="switchTabs('G')"
								class="position-relative d-flex align-items-center grp-mr pointer"
							>
								<div
									:class="candidateType === 'G' ? 'grp-tab-sel' : 'grp-tab'"
									class="d-flex align-items-center justify-content-center"
								>
									Groups
								</div>
								<div
									:class="candidateType === 'G' ? 'grp-slant-sel' : 'grp-slant'"
								></div>
							</div>
							<div
								v-if="roles.includes('GET_GROUP')"
								@click="switchTabs('R')"
								class="position-relative d-flex align-items-center pointer"
							>
								<div
									:class="candidateType === 'R' ? 'grp-tab-sel' : 'grp-tab'"
									class="d-flex align-items-center justify-content-center"
								>
									Recruitment groups
								</div>
								<div
									:class="candidateType === 'R' ? 'grp-slant-sel' : 'grp-slant'"
								></div>
							</div>
						</div>
						<div style="height: 50px; width: fit-content">
							<div v-if="candidateType == 'I'">
								<b-button
									v-if="roles.includes('PUSH_INDIVIDUAL')"
									class="addbtn mr-2 mb-2"
									@click="addIndividual()"
								>
									<img
										src="../../assets/icons/Reports/addIndividual.svg"
										alt
										class="mr-2 mb-1"
									/>
									<span>Add Individual</span>
								</b-button>
							</div>
							<div v-else-if="candidateType == 'G'">
								<b-button
									v-if="roles.includes('PUSH_GROUP')"
									class="addbtn mr-2 mb-2"
									@click="opengrpcontainer()"
								>
									<img
										src="../../assets/icons/Reports/addgroup.svg"
										alt
										class="mr-2 mb-1"
									/>
									<span>Add Group</span>
								</b-button>
							</div>
						</div>

						<!-- <div v-else style="height: 50px;"></div> -->
					</div>

					<!-- table new design starts from here -->
					<div class="group-main-table">
						<div class="group-table-head">
							<div class="group-check-width pl-2">
								<span
									class="text-center first-col qb-header-checkbox"
									v-if="groups.length !== 0 && deleteAccess"
								>
									<b-form-checkbox
										v-model="selectall"
										@change="selectAll()"
									></b-form-checkbox>
								</span>
							</div>
							<div class="group-check-width text-center">
								<span> Type </span>
							</div>
							<div class="text-center group-name-width">
								<span>
									{{ tableTitle }}
									<template v-if="sortColumn == 'groupName'">
										<img
											@click="sort('groupName'), (sorting = !sorting)"
											v-if="sorting == true"
											src="../../assets/sort - down.svg"
											alt
											class="pointer"
										/>
										<img
											v-else
											@click="sort('groupName'), (sorting = !sorting)"
											src="../../assets/sort - up.svg"
											alt
											class="pointer"
										/>
									</template>
									<img
										v-else
										@click="sort('groupName'), (sorting = !sorting)"
										src="../../assets/sort -none.svg"
										alt
										class="pointer"
									/>
								</span>
							</div>
							<div
								v-if="candidateType != 'I'"
								class="text-center group-cand-width"
							>
								<span>Candidates</span>
								<template v-if="sortColumn == 'candidateCount'">
									<img
										@click="sort('candidateCount'), (sorting = !sorting)"
										v-if="sorting == true"
										src="../../assets/sort - down.svg"
										alt
										class="pointer"
									/>
									<img
										v-else
										@click="sort('candidateCount'), (sorting = !sorting)"
										src="../../assets/sort - up.svg"
										alt
										class="pointer"
									/>
								</template>
								<img
									v-else
									@click="sort('candidateCount'), (sorting = !sorting)"
									src="../../assets/sort -none.svg"
									alt
									class="pointer"
								/>
							</div>
							<div
								class="text-center group-cand-width"
								:style="candidateType == 'I' ? 'width: 25% !important;' : ''"
							>
								<span>Tagged To</span>
							</div>
							<div
								class="text-center group-cand-width"
								:style="candidateType == 'I' ? 'width: 25% !important;' : ''"
							>
								<span>
									Created On
									<template v-if="sortColumn == 'createdAt'">
										<img
											@click="sort('createdAt'), (sorting = !sorting)"
											v-if="sorting == true"
											src="../../assets/sort - down.svg"
											alt
											class="pointer"
										/>
										<img
											v-else
											@click="sort('createdAt'), (sorting = !sorting)"
											src="../../assets/sort - up.svg"
											alt
											class="pointer"
										/>
									</template>
									<img
										v-else
										@click="sort('createdAt'), (sorting = !sorting)"
										src="../../assets/sort -none.svg"
										alt
										class="pointer"
									/>
								</span>
							</div>
							<div class="group-delete-icon-width">
								<div class="d-flex align-items-center justify-content-center">
									<div v-if="groups.length !== 0 && deleteAccess">
										<img
											v-if="pageTitle !== 'Recruitment Group'"
											:disabled="selectedGroupDel.length == 0"
											:class="
												selectedGroupDel.length == 0
													? 'disabled-text mr-4'
													: 'pointer mr-4'
											"
											v-b-popover.hover.top="'Delete'"
											v-b-modal.modal-delete
											src="../../assets/icons/access-delete.svg"
											alt
										/>
										<div v-else class="pr-4">Action</div>
									</div>
								</div>
							</div>
						</div>

						<div class="group-table-body p-1" id="eval-group-table">
							<template
								v-if="
									total == 0 &&
										searchTopicTest != '' &&
										searchTopicTest != 'Loader'
								"
							>
								<div
									class="d-flex flex-column align-items-center justify-content-center h-100"
								>
									<div>
										<img src="../../assets/searchnotfound.svg" alt />
									</div>
									<div class="text-center">
										<span class="searchnotfound">
											No matching results for
											<span class="searchtext text-break"
												>"{{ searchTopicTest }}"</span
											>.
										</span>
									</div>
								</div>
							</template>
							<template v-else-if="total == 0 && searchTopicTest == ''">
								<div
									class="d-flex flex-column align-items-center justify-content-center h-100"
								>
									<div>
										<img src="../../assets/searchnotfound.svg" alt />
									</div>
									<div class="text-center">
										<span class="searchnotfound"> No data found. </span>
									</div>
								</div>
							</template>
							<template v-else>
								<div
									v-for="group in groups"
									:key="group.groupID"
									:class="
										group.groupID == selectedGroup.groupID
											? 'group-changecolor-row'
											: 'group-table-row'
									"
								>
									<div class="text-center group-check-width">
										<b-form-checkbox
											v-if="deleteAccess"
											v-model="selectedGroupDel"
											@change="deselect()"
											:value="group.groupID"
										></b-form-checkbox>
									</div>
									<div class="text-center group-check-width">
										<span v-if="group.candidateType == 'I'">
											<img
												:id="'private-popover' + group.groupID"
												src="../../assets/icons/Reports/singlepep.svg"
												alt
											/>
										</span>
										<span v-if="group.candidateType == 'G'">
											<img
												:id="'private-popover' + group.groupID"
												src="../../assets/icons/Reports/grouppeople.svg"
												alt
											/>
										</span>
										<span v-if="group.candidateType == 'R'">
											<img
												:id="'private-popover' + group.groupID"
												src="../../assets/icons/share/recruitmentGroup.svg"
												alt
											/>
										</span>
										<b-popover
											:target="'private-popover' + group.groupID"
											triggers="hover"
											placement="top"
										>
											<div
												class="d-flex justify-content-center"
												:class="
													group.candidateType == 'R' ? 'swp-main-text' : ''
												"
											>
												{{
													group.candidateType == "I" ? "Individual" : "Group"
												}}
											</div>
											<div
												v-if="group.candidateType == 'R'"
												class="pr-tp-testhead"
											>
												Created from recruitment
											</div>
										</b-popover>
									</div>
									<div class="text-center group-name-width text-truncate">
										<span>{{ group.groupName }}</span>
									</div>
									<div
										v-if="candidateType != 'I'"
										class="text-center group-cand-width"
									>
										<span>{{ group.candidates.length }}</span>
									</div>
									<div
										class="text-center group-cand-width"
										:style="
											candidateType == 'I' ? 'width: 25% !important;' : ''
										"
									>
										<span v-if="group.configs.length == 1">
											<span v-if="Object.keys(group.configs[0]).length > 0"
												>1 test</span
											>
											<span v-else>0 test</span>
										</span>
										<span v-else>{{ group.configs.length }} Test</span>
									</div>
									<div
										class="text-center group-cand-width"
										:style="
											candidateType == 'I' ? 'width: 25% !important;' : ''
										"
									>
										<span>{{ group.createdAt | datefilter }}</span>
									</div>
									<div class="group-delete-icon-width text-center">
										<template>
											<img
												v-if="
													(candidateType != 'I' &&
														roles.includes('PUT_INDIVIDUAL') &&
														group.candidateType === 'I') ||
														(roles.includes('PUT_GROUP') &&
															group.candidateType === 'G')
												"
												v-b-popover.hover.top="'Edit'"
												src="../../assets/pencilicon.svg"
												alt
												class="m-2 pointer"
												@click="editPerticularGroup(group)"
											/>
										</template>
										<img
											v-if="group.view == false"
											v-b-popover.hover.top="'Preview'"
											src="../../assets/preview eye.svg"
											alt
											class="m-2 pointer"
											@click="viewParticularGroup(group)"
										/>
										<img
											v-else
											src="../../assets/visibility_off.svg"
											class="m-2 pointer"
											@click="unView(group)"
											alt
										/>
									</div>
								</div>
							</template>
						</div>

						<div
							class="paginaTion d-flex justify-content-between align-items-center"
						>
							<div class="d-flex">
								<span class="qb-gotopage-text p-1">Go to page</span>
								<b-form-input
									type="text"
									class="qb-pagination-num mr-1"
									v-model="goToPage"
									@keypress="allowNumbers"
									@keyup.enter="
										goToPage === null || goToPage == '' || !isValidPage
											? ''
											: goToPages(goToPage)
									"
								></b-form-input>
								<b-button
									class="qb-pagination-addbtn"
									@click="goToPages(goToPage)"
									:disabled="
										goToPage === null || goToPage == '' || !isValidPage
									"
								>
									<span>
										<img src="../../assets/whiterightarrow.svg" alt />
									</span>
								</b-button>
							</div>
							<div class="pagination">
								<b-pagination
									v-model.number="currentPage"
									@input="goToPageNum()"
									:total-rows="total"
									:per-page="count"
									align="center"
									first-number
									last-number
								>
									<template #prev-text>
										<span>
											<img src="../../assets/leftvector.svg" alt />
										</span>
									</template>
									<template #next-text>
										<span>
											<img src="../../assets/rightarrow.svg" alt />
										</span>
									</template>
								</b-pagination>
							</div>
							<div class="qb-gotopage-text mr-2">
								Results :
								<span v-if="pageStart > total">0</span>
								<span v-else>{{ pageStart }}</span>
								- {{ pageEnd }} of
								{{ total }}
							</div>
						</div>
					</div>
				</div>

				<Transition name="slide">
					<div
						class="grp-right-container relativeclass ml-2 mt-3"
						v-if="grpcontainer"
					>
						<!-- *******************************    VIEW INDIVIDUAL     ****************************** -->

						<div
							v-if="grptype == 'view' && selectedGroup.candidateType == 'I'"
							class="grp-view-individual p-3"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="grp-main-head">View Individual Details</div>
								<div class="d-flex align-items-center justify-content-between">
									<div class="pointer mt-2" @click="cancelGroupView()">
										<img
											v-b-popover.hover.top="'Close'"
											src="../../assets/roundClose.svg"
											alt
										/>
									</div>
								</div>
							</div>
							<div
								class="d-flex align-items-center grp-indiv-mail p-2 mt-4 mb-4 w-100"
							>
								<div>
									<img src="../../assets/orangeProfile.svg" alt />
								</div>
								<div
									class="ml-2 grp-mail-link text-truncate"
									v-if="selectedGroup.candidateType == 'G'"
								>
									{{ selectedGroup.groupName }}
								</div>
								<div
									class="statstext d-flex ml-3 mt-3 mb-3 text-truncate"
									v-else
								>
									{{ selectedGroup.groupName }}
								</div>
							</div>

							<hr />

							<!-- for individual -->
							<div
								class="d-flex align-items-center justify-content-between mb-1 mr-2"
							>
								<div class="grp-tagged-test-head">Tagged Tests</div>
								<span v-if="selectedGroup.configs.length == 1">
									<span
										class="grp-tagged-test-head"
										v-if="Object.keys(selectedGroup.configs[0]).length > 0"
										>Total Tests: 1</span
									>
									<span class="grp-tagged-test-head" v-else
										>Total Tests: 0</span
									>
								</span>
								<span class="grp-tagged-test-head" v-else
									>Total Tests: {{ selectedGroup.configs.length }}</span
								>
							</div>

							<div class="get-tagged-individual">
								<div
									v-for="(tag, index) in viewCandidateGroup"
									:key="index"
									class="grp-tagged-test-card p-3 mt-2 mr-1"
								>
									<div class="grp-test-head mt-2">Topic Name</div>
									<div class="grp-test-subhead mb-3 mt-1 ellipsis">
										{{ tag.topicName }}
									</div>
									<div class="grp-test-head">Test Name</div>
									<div class="grp-test-subhead mt-1 ellipsis">
										{{ tag.testName }}
									</div>

									<hr />

									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div
											class="d-flex flex-column align-items-center justify-content-between"
										>
											<div class="grp-evalute-asmnt-text">Difficulty level</div>
											<div class="grp-green-text mt-1">
												{{ tag.difficultyWord }}
											</div>
										</div>
										<div
											class="d-flex flex-column align-items-center justify-content-between"
										>
											<div class="grp-evalute-asmnt-text">No.of Section</div>
											<div class="grp-blue-text mt-1">
												{{ tag.numOfSections }}
											</div>
										</div>
										<div
											class="d-flex flex-column align-items-center justify-content-between"
										>
											<div class="grp-evalute-asmnt-text">No.of Questions</div>
											<div class="grp-yellow-text mt-1">
												{{ tag.totalNumOfQuestions }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- ********************   VIEW GROUP DETAILS     ***********************  -->

						<div
							v-if="
								grptype == 'view' &&
									(selectedGroup.candidateType == 'G' ||
										selectedGroup.candidateType == 'R')
							"
							class="grp-view-group p-3"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="grp-main-head">View Group Details</div>
								<div class="d-flex align-items-center justify-content-between">
									<div class="mr-3 pointer">
										<template>
											<img
												@click="editPerticularGroup(selectedGroup)"
												class="mb-1"
												v-if="
													selectedGroup.candidateType === 'G' &&
														roles.includes('PUT_GROUP')
												"
												v-b-popover.hover.top="'Edit'"
												src="../../assets/pencilicon.svg"
												alt
											/>
										</template>
									</div>
									<div class="pointer" @click="cancelGroupView()">
										<img
											v-b-popover.hover.top="'Close'"
											src="../../assets/roundClose.svg"
											alt
										/>
									</div>
								</div>
							</div>
							<div
								class="right-overflow"
								style="overflow: auto; height: calc(100vh - 160px)"
							>
								<div class="grp-search-candidate p-3 mt-4 mr-1">
									<div
										class="d-flex align-items-center justify-content-between mb-3"
									>
										<div class="d-flex align-items-center" style="width: 60%">
											<div>
												<img src="../../assets/blueGroup.svg" alt />
											</div>
											<div class="grp-mail-link ml-2 text-truncate">
												{{ selectedGroup.groupName }}
											</div>
										</div>
										<div
											class="d-flex align-items-center grp-total-test-text justify-content-end"
											style="width: 35%"
										>
											<div>Total Candidates :</div>
											<div class="ml-1">
												{{ selectedGroup.candidates.length }}
											</div>
										</div>
									</div>
									<div class="item grp-second-section">
										<span class="grp-search-bar-search">
											<img src="../../assets/searchicon.svg" alt />
											<b-form-input
												class="grp-search-bar-searchbtn"
												v-model="searchVariable"
												placeholder="Search Candidate"
												@change="searchVariable = ''"
											></b-form-input>
										</span>
									</div>
									<div class="grp-candidates-overflow mt-1">
										<div
											v-if="searchVariable === '' && filterVens.length == 0"
											class="grp-tagged-test-head mt-2 d-flex justify-content-center"
										>
											No Candidates in the Group
										</div>
										<div v-if="filterVens.length !== 0">
											<div
												v-for="candidate in filterVens"
												:key="candidate"
												class="d-flex align-items-center p-2"
											>
												<div>
													<img src="../../assets/orangeProfile.svg" alt />
												</div>
												<div
													class="ml-2 grp-mail-link"
													style="word-break: break-all"
												>
													{{ candidate }}
												</div>
											</div>
										</div>

										<div
											v-if="searchVariable !== '' && filterVens.length == 0"
											class="grp-tagged-test-head mt-2 d-flex justify-content-center"
										>
											No candidates found
										</div>
									</div>
								</div>
								<hr />

								<!-- for group tagged -->
								<div>
									<div
										class="d-flex align-items-center justify-content-between mb-1 mr-2 mt-3"
									>
										<div class="grp-tagged-test-head">Tagged Tests</div>
										<span v-if="selectedGroup.configs.length == 1">
											<span
												class="grp-tagged-test-head"
												v-if="Object.keys(selectedGroup.configs[0]).length > 0"
												>Total Tests: 1</span
											>
											<span class="grp-tagged-test-head" v-else
												>Total Tests: 0</span
											>
										</span>
										<span class="grp-tagged-test-head" v-else
											>Total Tests: {{ selectedGroup.configs.length }}</span
										>
									</div>
									<div>
										<div
											v-for="tags in viewCandidateGroup"
											:key="tags.id"
											class="grp-tagged-test-card p-3 mt-2 mr-1"
										>
											<div class="grp-test-head mt-2">Topic Name</div>
											<div class="grp-test-subhead mb-3 mt-1 ellipsis">
												{{ tags.topicName }}
											</div>
											<div class="grp-test-head">Test Name</div>
											<div class="grp-test-subhead mt-1 ellipsis">
												{{ tags.testName }}
											</div>

											<hr />

											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div
													class="d-flex flex-column align-items-center justify-content-between"
												>
													<div class="grp-evalute-asmnt-text">
														Difficulty level
													</div>
													<div class="grp-green-text mt-1">
														{{ tags.difficultyWord }}
													</div>
												</div>
												<div
													class="d-flex flex-column align-items-center justify-content-between"
												>
													<div class="grp-evalute-asmnt-text">
														No.of Section
													</div>
													<div class="grp-blue-text mt-1">
														{{ tags.numOfSections }}
													</div>
												</div>
												<div
													class="d-flex flex-column align-items-center justify-content-between"
												>
													<div class="grp-evalute-asmnt-text">
														No.of Questions
													</div>
													<div class="grp-yellow-text mt-1">
														{{ tags.totalNumOfQuestions }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- *****************   EDIT GROUP DETAILS   *******************  -->

						<div
							v-if="
								grptype == 'edit' &&
									(selectedGroup.candidateType == 'G' ||
										selectedGroup.candidateType == 'R')
							"
							class="grp-edit-group p-3"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="grp-main-head">Edit Group</div>
								<div class="pointer" @click="cancelGroupView()">
									<img
										v-b-popover.hover.top="'Close'"
										src="../../assets/roundClose.svg"
										alt
									/>
								</div>
							</div>
							<div class="grp-edit-search-candidate p-3 mt-4">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center" style="width: 60%">
										<div>
											<img src="../../assets/blueGroup.svg" alt />
										</div>
										<div class="grp-mail-link ml-2 text-truncate">
											{{ selectedGroup.groupName }}
										</div>
									</div>
									<div
										class="d-flex align-items-center grp-total-test-text justify-content-end"
										style="width: 35%"
									>
										<div>Total Candidates :</div>
										<div>{{ selectedGroup.candidates.length }}</div>
									</div>
								</div>

								<div class="topDiv mt-4 newGroupDiv">
									<label class="fieldsetStyle">
										Group Name &nbsp;
										<span class="asterik">*</span>
									</label>
									<b-form-input
										v-on:keyup.enter="updateGroup()"
										class="inputField"
										id="input-1"
										placeholder="Give Group Name"
										v-model.trim="selectedGroup.groupName"
										:class="{ error: $v.selectedGroup.groupName.$error }"
									></b-form-input>
									<div
										style="position: absolute; top: 4px; right: 12px"
										v-if="
											$v.selectedGroup.groupName.$dirty &&
												!$v.selectedGroup.groupName.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt />
									</div>
									<div
										style="position: absolute; top: 5px; right: 12px"
										v-if="!$v.selectedGroup.groupName.maxLength"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 128 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										style="position: absolute; top: 4px; right: 12px"
										v-if="
											$v.selectedGroup.groupName.required &&
												!$v.selectedGroup.groupName.alpha
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Enter valid Name',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt />
									</div>
								</div>

								<div
									class="relativeclass mt-4 newGroupDiv"
									ref="expdropdownselectedGroup"
								>
									<div class="relativeclass mt-3 pointer">
										<div
											v-b-modal.excel-modal
											class="clearfilter import-excel-pos"
										>
											Import excel
										</div>
										<label class="fieldsetStyle">
											Email &nbsp;
											<span class="asterik">*</span>
										</label>
										<b-form-tags
											v-model="selectedGroup.candidates"
											no-outer-focus
											class="groupshare-formtag"
										>
											<template v-slot="{ inputAttrs }">
												<b-input-group aria-controls="my-custom-tags-list">
													<b-form-input
														v-model.trim="$v.editIndividualEmail.$model"
														v-bind="inputAttrs"
														v-on:keyup.enter="customHandler()"
														@keyup="convertToLowerCase"
														@input="printEdit"
														@click="toggleDropdownselectedGroup()"
														placeholder="New Email - Enter to Add"
														class="Group-Individual-form-control"
														:class="
															emailSelectedEmpty
																? 'error'
																: '' || { error: $v.editIndividualEmail.$error }
														"
													></b-form-input>
													<div
														style="position: absolute; top: 2px; right: 35px"
														v-if="
															($v.editIndividualEmail.$dirty &&
																!$v.editIndividualEmail.required) ||
																emailSelectedEmpty
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
														variant="primary"
													>
														<img src="../../assets/deletepopupicon.svg" alt />
													</div>
													<div
														style="position: absolute; top: 2px; right: 35px"
														v-if="
															!$v.editIndividualEmail.alpha ||
																($v.editIndividualEmail.required &&
																	!$v.editIndividualEmail.email)
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Enter valid email address',
														}"
														variant="primary"
													>
														<img src="../../assets/deletepopupicon.svg" alt />
													</div>
													<b-input-group-append class="addtaginput">
														<b-button
															@click="customAddTag()"
															variant="outline"
															class="cursor-pointer p-2"
														>
															<img
																src="../../assets/addicongraywhite.svg"
																alt
															/>
														</b-button>
													</b-input-group-append>
												</b-input-group>
											</template>
										</b-form-tags>
									</div>
									<div
										v-if="mailids && optionssearch.length > 0"
										class="GI-qb-dropdown-option-add p-1"
									>
										<div class="GI-checkboxcontainer-edit">
											<div
												class="p-2 swp-jdTypeCheck"
												v-for="i in optionssearch"
												:key="i.groupID"
												style="display: grid"
											>
												<b-form-checkbox
													v-model="selectedGroup.candidates"
													class="swp-check-email mr-2"
													:value="i.groupName"
												>
													<span class="pointer">{{ i.groupName }}</span>
												</b-form-checkbox>
											</div>
										</div>
									</div>
									<div class="errorclass" v-if="groupLengthError">
										Group should contain two or more people
									</div>
								</div>

								<!-- selected email of edit group container -->
								<div class="pointer">
									<div
										class="GI-card-height-create-g p-2 mt-2"
										v-if="selectedGroup.candidates.length != 0"
									>
										<div class="d-flex align-items-center">
											<div>
												<img
													src="../../assets/icons/Reports/grouppeople.svg"
													alt
												/>
											</div>
											<div class="swp-main-text ml-2">Group Candidates</div>
										</div>

										<hr />
										<div class="Edit-group-content">
											<div
												v-for="(candidate, index) in selectedGroup.candidates"
												:key="candidate"
												class="d-flex-align-items-center p-1"
											>
												<div class="d-flex justify-content-between">
													<div class="d-flex justify-content-between">
														<span>
															<img
																src="../../assets/icons/Reports/singlepep.svg"
																alt
																class="mr-2"
															/>
														</span>
														<div class="shareview-details-email mt-1">
															{{ candidate }}
														</div>
													</div>
													<div class="shareview-details-text mt-1">
														<span v-b-popover.hover.right="'Remove'">
															<img
																src="../../assets/icons/Reports/removeEmail.svg"
																alt
																class="mt-1 pointer"
																@click="removeSelectedEmail(index)"
															/>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex align-items-center grp-twobtns">
								<div
									class="GI-cancelbtntext mr-3 pointer"
									@click="cancel(), (grpcontainer = false)"
								>
									Cancel
								</div>
								<b-button
									class="addbtn pointer pl-4 pr-4"
									@click="updateGroup()"
									>Update</b-button
								>
							</div>
						</div>

						<!-- *******************  EDIT INDIVIDUAL  ********************* -->

						<div
							v-if="grptype == 'edit' && selectedGroup.candidateType == 'I'"
							class="grp-edit-individual p-3"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="grp-main-head">Edit Individual</div>
								<div class="pointer" @click="cancel(), (grpcontainer = false)">
									<img
										v-b-popover.hover.top="'Close'"
										src="../../assets/roundClose.svg"
										alt
									/>
								</div>
							</div>
							<hr />

							<div class="topDiv mt-4 newGroupDiv">
								<label class="fieldsetStyle">
									Email ID &nbsp;
									<span class="asterik">*</span>
								</label>
								<b-form-input
									v-on:keyup.enter="updateIndividual()"
									class="inputField"
									id="input-1"
									placeholder="Enter Email ID"
									v-model.trim="$v.individualCandidate.$model"
									:class="{ error: $v.individualCandidate.$error }"
								></b-form-input>
								<div
									style="position: absolute; top: 2px; right: 12px"
									v-if="
										$v.individualCandidate.$dirty &&
											!$v.individualCandidate.required
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt />
								</div>
								<div
									style="position: absolute; top: 2px; right: 12px"
									v-if="
										!$v.individualCandidate.alpha ||
											($v.individualCandidate.required &&
												!$v.individualCandidate.email)
									"
									v-b-popover.hover.top.v-danger="{
										content: 'Enter valid email address',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt />
								</div>
							</div>
							<div class="d-flex align-items-center grp-twobtns">
								<div
									class="GI-cancelbtntext mr-3 pointer"
									@click="cancel(), (grpcontainer = false)"
								>
									Cancel
								</div>
								<b-button
									class="addbtn pointer pl-4 pr-4"
									@click="updateIndividual()"
									>Update</b-button
								>
							</div>
						</div>

						<!-- *******************  ADD INDIVIDUAL  *************************-->

						<div
							v-if="grptype == 'individual' && candidateType == 'I'"
							class="grp-add-individual"
						>
							<div class="p-3 position-relative">
								<div class="d-flex align-items-center justify-content-between">
									<div class="grp-main-head">Add Individual</div>
									<div class="pointer" @click="cancelIndividualCandidate()">
										<img
											v-b-popover.hover.top="'Close'"
											src="../../assets/roundClose.svg"
											alt
										/>
									</div>
								</div>
								<hr />

								<div class="topDiv mt-4 newGroupDiv">
									<label class="fieldsetStyle">
										Email ID &nbsp;
										<span class="asterik">*</span>
									</label>
									<b-form-input
										v-on:keyup.enter="saveIndividual()"
										class="inputField"
										id="input-1"
										placeholder="Enter Email ID"
										@keyup="convertToLowerCase"
										v-model.trim="$v.addIndividualMail.$model"
										:class="{ error: $v.addIndividualMail.$error }"
									></b-form-input>
									<div
										style="
                      position: absolute;
                      top: 3px;
                      right: 8px;
                      background-color: white;
                    "
										v-if="
											$v.addIndividualMail.$dirty &&
												!$v.addIndividualMail.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt />
									</div>
									<div
										style="
                      position: absolute;
                      top: 3px;
                      right: 8px;
                      background-color: white;
                    "
										v-if="
											!$v.addIndividualMail.alpha ||
												($v.addIndividualMail.required &&
													!$v.addIndividualMail.email)
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Enter valid email address',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt />
									</div>
								</div>
							</div>

							<div class="grp-twobtns d-flex justify-content-end p-3">
								<div class="d-flex align-items-center">
									<div
										@click="cancelIndividualCandidate()"
										class="GI-cancelbtntext pointer"
									>
										Cancel
									</div>
									<b-button
										class="ml-3 pl-4 pr-4 addbtn pointer"
										@click="saveIndividual()"
										>Add</b-button
									>
								</div>
							</div>
						</div>

						<!-- *******************  ADD GROUP  *********************** -->

						<div
							v-if="grptype == 'create' && candidateType == 'G'"
							class="grp-create-group"
						>
							<div class="p-3 position-relative">
								<div class="d-flex align-items-center justify-content-between">
									<div class="grp-main-head">Create Group</div>
									<div class="pointer" @click="cancelGroupView()">
										<img
											v-b-popover.hover.top="'Close'"
											src="../../assets/roundClose.svg"
											alt
										/>
									</div>
								</div>
								<hr />

								<div class="topDiv mt-4">
									<label class="fieldsetStyle">
										Group Name &nbsp;
										<span class="asterik">*</span>
									</label>
									<b-form-input
										v-on:keyup.enter="createGroup()"
										style="padding: 12px"
										class="inputField"
										id="input-1"
										placeholder="Enter Group Name"
										v-model.trim="selectedGroup.groupName"
										:class="{
											error:
												$v.selectedGroup.groupName.$error ||
												!$v.selectedGroup.groupName.maxLength ||
												($v.selectedGroup.groupName.required &&
													!$v.selectedGroup.groupName.alpha),
										}"
									></b-form-input>
									<div
										style="position: absolute; top: 2px; right: 12px"
										v-if="
											$v.selectedGroup.groupName.$dirty &&
												!$v.selectedGroup.groupName.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt />
									</div>
									<div
										style="position: absolute; top: 2px; right: 12px"
										v-if="
											$v.selectedGroup.groupName.required &&
												!$v.selectedGroup.groupName.alpha
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Enter valid Name',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt />
									</div>
									<div
										style="position: absolute; top: 5px; right: 12px"
										v-if="!$v.selectedGroup.groupName.maxLength"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 128 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
								<div class="errorclass" v-if="groupLengthError">
									Group should contain two or more people
								</div>

								<div
									class="relativeclass mt-4 newGroupDiv"
									ref="expdropdownselectedGroup"
								>
									<div
										v-b-modal.excel-modal
										class="clearfilter import-excel-pos"
									>
										Import excel
									</div>
									<div class="mt-3 pointer">
										<label class="fieldsetStyle">
											Email &nbsp;
											<span class="asterik">*</span>
										</label>
										<b-form-tags
											v-model="selectedGroup.candidates"
											no-outer-focus
											class="groupshare-formtag"
											separator=" ,;"
										>
											<template v-slot="{ inputAttrs }">
												<b-input-group aria-controls="my-custom-tags-list">
													<b-form-input
														@click="toggleDropdownselectedGroup"
														v-model.trim="$v.editIndividualEmail.$model"
														v-bind="inputAttrs"
														v-on:keyup.enter="customHandler"
														@keyup="convertToLowerCase"
														@input="printEdit"
														placeholder="New Email - Enter to Add"
														class="Group-Individual-form-control"
														:class="
															emailSelectedEmpty
																? 'error'
																: '' || { error: $v.editIndividualEmail.$error }
														"
													></b-form-input>

													<div
														style="
                              position: absolute;
                              top: 2px;
                              right: 28px;
                              background-color: white;
                              padding-right: 5px;
                            "
														v-if="
															($v.editIndividualEmail.$dirty &&
																!$v.editIndividualEmail.required) ||
																emailSelectedEmpty
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
														variant="primary"
													>
														<img src="../../assets/deletepopupicon.svg" alt />
													</div>
													<div
														style="
                              position: absolute;
                              top: 2px;
                              right: 28px;
                              background-color: white;
                              padding-right: 5px;
                            "
														v-if="
															!$v.editIndividualEmail.alpha ||
																($v.editIndividualEmail.required &&
																	!$v.editIndividualEmail.email)
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Enter valid email address',
														}"
														variant="primary"
													>
														<img src="../../assets/deletepopupicon.svg" alt />
													</div>

													<b-input-group-append class="addtaginput">
														<b-button
															@click="customAddTag()"
															variant="outline"
															class="cursor-pointer p-2"
														>
															<img
																v-b-popover.hover.top="'Add'"
																style="background-color: white"
																src="../../assets/addicongraywhite.svg"
																alt
															/>
														</b-button>
													</b-input-group-append>
												</b-input-group>
											</template>
										</b-form-tags>
									</div>
									<div
										v-if="mailids && optionssearch.length > 0"
										class="GI-qb-dropdown-option-add p-1"
									>
										<div class="GI-checkboxcontainer">
											<div
												class="p-2 swp-jdTypeCheck"
												v-for="i in optionssearch"
												:key="i.id"
												style="display: grid"
											>
												<b-form-checkbox
													v-model="selectedGroup.candidates"
													class="swp-check-email mr-2"
													:value="i.groupName"
													@change="editIndividualEmail = ''"
												>
													<span class="pointer">{{ i.groupName }}</span>
												</b-form-checkbox>
											</div>
										</div>
									</div>

									<!-- selected group of added email -->
									<div
										class="pointer"
										v-if="selectedGroup.candidates.length > 0"
									>
										<div class="GI-card-height-create-g p-2 mt-2">
											<div class="d-flex align-items-center">
												<div>
													<img
														src="../../assets/icons/Reports/grouppeople.svg"
														alt
													/>
												</div>
												<div class="swp-main-text ml-2">Group Candidates</div>
											</div>

											<hr />
											<div class="create-group-content">
												<div
													class="d-flex-align-items-center p-1"
													v-for="(candidate, index) in selectedGroup.candidates"
													:key="candidate"
												>
													<div class="d-flex justify-content-between">
														<div class="d-flex justify-content-between">
															<span>
																<img
																	src="../../assets/icons/Reports/singlepep.svg"
																	alt
																	class="mr-2"
																/>
															</span>
															<div class="shareview-details-email mt-1">
																{{ candidate }}
															</div>
														</div>
														<div class="shareview-details-text mt-1">
															<span>
																<img
																	v-b-popover.hover.right="'Remove'"
																	src="../../assets/icons/Reports/removeEmail.svg"
																	alt
																	class="mt-1 pointer"
																	@click="removeSelectedEmail(index)"
																/>
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- evaluator -->
							</div>

							<div
								class="grp-group-detail-footer grp-twobtns-2 d-flex justify-content-end p-3"
							>
								<div class="d-flex align-items-center">
									<div
										@click="
											(sectionmodal = !sectionmodal), (grpcontainer = false)
										"
										class="GI-cancelbtntext pointer"
									>
										Cancel
									</div>
									<b-button
										@click="createGroup()"
										class="ml-3 pl-4 pr-4 addbtn pointer"
										>Add</b-button
									>
								</div>
							</div>
						</div>
					</div>
				</Transition>
			</div>
		</div>
		<b-modal
			id="modal-delete"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt />
			</div>
			<div @click="$bvModal.hide('modal-delete')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete ?</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span>
				<span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteGroup()">Delete</b-button>
			</div>
		</b-modal>
		<b-modal
			id="confirm-edit"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt />
			</div>
			<div @click="$bvModal.hide('confirm-edit')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to edit ?</span>
			</div>
			<div class="mt-2 caution-modal-text">
				This group is tagged to more than one test. These changes will reflect
				in all other tests
			</div>
			<div class="mt-2 normaltext">
				<span class="asterik">*</span>
				<span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn mr-2" @click="confirm()">Confirm</b-button>
				<div
					class="sec-canceltext pointer"
					@click="cancel(), (grpcontainer = false)"
				>
					Cancel
				</div>
			</div>
		</b-modal>
		<b-modal
			id="excel-modal"
			centered
			hide-footer
			hide-header
			@show="removeExcelFromPopUp"
			@hidden="removeExcelFromPopUp"
			class="qb-add-ques-modal"
			no-stacking
			no-close-on-backdrop
		>
			<div class="">
				<div class="">
					<div @click="$bvModal.hide('excel-modal')" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<div class="modalheading">Import Excel</div>
					<div class="d-flex justify-content-center align-items-center mt-3">
						<input
							ref="excel-upload-input"
							class="excel-upload-input"
							type="file"
							accept=".xlsx, .xls"
							@change="handleClick"
						/>

						<b-button @click="handleUpload" class="addbtn mr-2 pl-2 pr-2">
							<img
								src="../../assets/icons/uploadexcel/uploadicon.svg"
								alt=""
								class="mr-2 mb-1"
							/>
							<span class="">Browse excel file here</span>
						</b-button>
					</div>
				</div>

				<div class="uploadfile-container mt-3" v-if="excelFile != ''">
					<div class="d-flex justify-content-between align-items-center mt-1">
						<div class="uploadfile-head-text">{{ excelFile.name }}</div>
						<div>
							<img
								src="../../assets/icons/uploadexcel/closeicon.svg"
								alt=""
								class="pointer"
								@click="removeExcelFile"
							/>
						</div>
					</div>
				</div>

				<div class="mt-4 d-flex justify-content-between">
					<div>
						<b-button
							variant="outline"
							class="cursor-pointer p-2"
							@click="getExcelTemplate()"
						>
							<span
								><img
									src="../../assets/icons/uploadexcel/downloadicon.svg"
									alt=""
							/></span>
							<span class="ml-2 qb-add-more-matches">Download Template</span>
						</b-button>
					</div>
					<div class="">
						<b-button
							variant="out-second view-feedbtn ml-1"
							squared
							@click="$bvModal.hide('excel-modal'), removeExcelFile()"
							>Cancel
						</b-button>
						<b-button
							:disabled="excelFile == ''"
							class="addbtn ml-3 pr-3 pl-3"
							@click="acceptExcel()"
							>Upload</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
let XLSX = require("xlsx");
import {
	getAllGroups,
	taggedGroup,
	postShareGroup,
	putShareGroup,
	generateLink,
	shareLink,
	deleteShareGroup,
	gettaggedtestsdetails,
	getGroupTemplate,
	postGroupExcel,
} from "../../utils/apiFunctions";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
import {
	required,
	email,
	requiredIf,
	helpers,
	maxLength,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
	name: "Group",
	mixins: [successToast, errorToast],
	data() {
		return {
			excelFile: "",
			// openInd: true,
			// openGrp: false,
			// openRec: false,
			addIndividualMail: "",
			loopVar: 7,
			loopV: 3,
			evaluatorSelect: false,
			LoaderStatus: false,
			grptype: "",
			mailidsearch: "",
			individualCandidate: "",
			individualmailsearch: "",
			groupSearch: "",
			filterType: "",
			pageStart: 0,
			pageEnd: null,
			prevPage: null,
			total: null,
			totalPages: null,
			sortColumn: "createdAt",
			sorting: false,
			count: 50,
			currentPage: 1,
			goToPage: null,
			candidateType: "I",
			filtercount: 0,
			selectall: false,
			sortOrder: false,
			filtermodalshow: false,
			editIndividual: false,
			individualmail: false,
			grpcontainer: false,
			sectionmodal: false,
			emailSelectedEmpty: false,
			mailids: false,
			groupLengthError: false,
			check: true,
			editIndividualEmail: "",
			selectedGroup: {
				groupName: "",
				candidates: [],
			},
			candidateTypes: [
				{
					item: "G",
					name: "Group",
				},
				{
					item: "I",
					name: "Individual",
				},
				{
					item: "R",
					name: "Recruitement groups",
				},
			],
			selectedGroupDel: [],
			groupOptions: [],
			individualemials: [],
			emailSelected: [], // Must be an array reference!
			groups: [],
			options: [],
			viewCandidateGroup: [],
			viewCandidateindividual: [],
			newID: "",
			searchVariable: "",
			newGroupTypes: "",
			selectedDataType: "",
			selectedIndividual: false,
			selectedGroupsVal: false,
		};
	},
	components: {
		Spinner,
	},
	created() {
		//check access to group and individual
		if (
			this.roles.includes("GET_INDIVIDUAL") &&
			!this.roles.includes("GET_GROUP")
		) {
			this.candidateType = "I";
		} else if (
			!this.roles.includes("GET_INDIVIDUAL") &&
			this.roles.includes("GET_GROUP")
		) {
			this.candidateType = "G";
		}
		this.$store.commit("searchVUEX/saveSelectedIndGrp", this.pageTitle);
		this.getShareGroupData();
	},
	mounted() {
		const el = document.getElementById("top1");
		el.addEventListener("click", this.simple, false);
	},
	validations: {
		selectedGroup: {
			groupName: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^((?!@).)*$/),
			},
		},
		individualCandidate: {
			required,
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},
		addIndividualMail: {
			required,
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},
		editIndividualEmail: {
			required: requiredIf(function() {
				return this.selectedGroup.candidates.length < 2;
			}),
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},
	},
	watch: {
		candidateType() {
			this.$store.commit("searchVUEX/saveSelectedIndGrp", this.pageTitle);
		},
		candidateTypes() {
			this.resetvalues(this.candidateTypes);
		},
		searchTopicTest(newValue, oldValue) {
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.$forceUpdate();
			this.grpcontainer = false;
			if (newValue != oldValue) {
				this.getShareGroupData();
			}
		},
	},
	computed: {
		deleteAccess() {
			//check if the user have access to delete data
			if (this.candidateType == "G" || this.candidateType == "R") {
				return this.roles.includes("DELETE_GROUP");
			} else if (this.candidateType == "I") {
				return this.roles.includes("DELETE_INDIVIDUAL");
			} else if (
				this.roles.includes("DELETE_INDIVIDUAL") ||
				this.roles.includes("DELETE_GROUP")
			) {
				return true;
			}
			return false;
		},
		pageTitle() {
			//set page title
			if (this.candidateType == "G") {
				return "Group";
			} else if (this.candidateType == "R") {
				return "Recruitment Group";
			} else {
				return "Individual's";
			}
		},
		tableTitle() {
			////set table title
			if (this.candidateType == "G" || this.candidateType == "R") {
				return "Group Name";
			} else {
				return "Email ID";
			}
		},
		// To check if it does not contain an alphabet or zero
		isValidPage() {
			return /^\d*$/.test(this.goToPage) && this.goToPage != 0;
		},
		filterVens() {
			return this.selectedGroup.candidates.filter((data) => {
				return (
					!this.searchVariable ||
					data.toLowerCase().includes(this.searchVariable.toLowerCase())
				);
			});
		},

		optionssearch() {
			return this.options.filter((data) => {
				if (data.candidateType == "I") {
					return (
						!this.editIndividualEmail ||
						data.groupName
							.toLowerCase()
							.includes(this.editIndividualEmail.toLowerCase())
					);
				}
			});
		},
		individualemailsearch() {
			return this.individualemials.filter((data) => {
				return (
					!this.individualmailsearch ||
					data.groupName
						.toLowerCase()
						.includes(this.individualmailsearch.toLowerCase())
				);
			});
		},
		groupOptionSearch() {
			return this.groupOptions.filter((data) => {
				return (
					!this.groupSearch ||
					data.groupName.toLowerCase().includes(this.groupSearch.toLowerCase())
				);
			});
		},
		// getSearchTopicTestc(){
		//   return true
		// },
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters(["roles"]),
	},
	methods: {
		getExcelTemplate() {
			getGroupTemplate()
				.then((res) => {
					this.downloadLink = res.data.data.downloadLink;
					console.log(this.downloadLink, "down load");
					this.download(this.downloadLink);
				})
				.catch((err) => {
					throw err;
				});
		},
		download(url) {
			const link = document.createElement("a");
			link.href = url;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		removeExcelFile() {
			this.$refs["excel-upload-input"].value = null;
			this.excelFile = "";
		},
		acceptExcel() {
			let formData = new FormData();
			formData.append("file", this.excelFile);
			postGroupExcel(formData).then((res) => {
				if (res.status == 200) {
					this.excelEmails = res.data.data.emails;
					console.log(this.excelEmails, "res for group");
					this.selectedGroup.candidates.push(...this.excelEmails);
					console.log(this.selectedGroup.candidates, "ppppp");
					this.successToast("Excel sheets uploaded successfully");
				} else if (res.status === 400 || res.status === 404) {
					this.$nextTick(() => {
						this.errorToast(res.data.detail);
					});
				} else {
					this.errorToast("Something went wrong");
				}
				this.$bvModal.hide("excel-modal");
			});
		},
		handleUpload() {
			this.$refs["excel-upload-input"].click();
		},
		handleClick: function(event) {
			this.excelFile = event.target.files ? event.target.files[0] : null;
			if (this.excelFile) {
				const reader = new FileReader();

				reader.onload = (e) => {
					/* Parse data */
					const bstr = e.target.result;
					const wb = XLSX.read(bstr, { type: "binary" });

					this.SheetName = wb.SheetNames[0];
				};

				reader.readAsBinaryString(this.excelFile);
			}
		},
		removeExcelFromPopUp() {
			this.excelFile = "";
		},
		allowNumbers(event) {
			if (!/^\d$/.test(event.key)) {
				event.preventDefault();
			}
		},
		switchTabs(flag) {
			this.currentPage = 1;
			this.selectall = false;
			this.goToPage = null;
			this.selectedGroupDel = [];
			this.cancelGroupView();
			this.candidateType = flag; // Update the candidateType property with the provided flag value
			this.getShareGroupData();
			this.LoaderStatus = true;
		},
		toggleDropdownselectedGroup() {
			this.mailids = !this.mailids;
			if (this.mailids) {
				document.addEventListener("click", this.closeDropdownselectedGroup);
			} else {
				document.removeEventListener("click", this.closeDropdownselectedGroup);
			}
		},
		closeDropdownselectedGroup(event) {
			if (!this.$refs.expdropdownselectedGroup.contains(event.target)) {
				this.mailids = false;
				document.removeEventListener("click", this.closeDropdownselectedGroup);
			}
		},
		nextSimple() {
			this.mailids = false;
		},
		simple() {
			this.mailids = false;
		},
		printEdit() {
			this.emailSelectedEmpty = -false;
		},
		converEditIndividualEmail() {
			this.editIndividualEmail = this.editIndividualEmail.toLowerCase();
		},
		async getTaggedtest() {
			try {
				let payload = {
					groupID: this.newID,
				};
				const res = await gettaggedtestsdetails(payload);
				if (res.status == 200) {
					this.viewCandidateGroup = res.data.data.taggedTests;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		convertToLowerCase() {
			this.individualCandidate = this.individualCandidate.toLowerCase();
			this.editIndividualEmail = this.editIndividualEmail.toLowerCase();
		},

		// The pagination buttons functionality allow you to move backward and forward through the page
		goToPages(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getShareGroupData();
		},
		goToPageNum() {
			this.getShareGroupData();
		},
		customHandler() {
			if (!this.$v.editIndividualEmail.$invalid) {
				this.selectedGroup.candidates.push(this.$v.editIndividualEmail.$model);
				this.editIndividualEmail = "";
				this.$forceUpdate();
				this.$v.$reset();
			}
		},
		customAddTag() {
			console.log("tt");
			if (!this.$v.editIndividualEmail.$invalid) {
				this.selectedGroup.candidates.push(this.$v.editIndividualEmail.$model);
				this.editIndividualEmail = "";
				this.$forceUpdate();
				this.$v.$reset();
			}
		},
		cancelGroupView() {
			this.grpcontainer = false;
			this.groups.forEach((object) => {
				object.view = false;
			});
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.$forceUpdate();
		},
		async getShareGroupData() {
			this.LoaderStatus = true;
			try {
				let payload = {
					page: this.currentPage - 1,
					count: this.count,
					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					filters: {
						candidateType: this.candidateType,
						status: "true",
					},
					// searchColumn: {
					//   groupName: "",
					//   candidateType: "",
					// },
					searchQuery: this.searchTopicTest,
				};
				const res = await getAllGroups(payload);
				if (res.status == 200) {
					this.LoaderStatus = false;
					this.groups = res.data.data.data;
					this.groups.forEach((object) => {
						object.view = false;
					});
					this.total = res.data.data.total;
					this.pageStart = res.data.data.pageStart;
					this.pageEnd = res.data.data.pageEnd;
					this.prevPage = res.data.data.prevPage;
					this.totalPages = Math.ceil(
						parseInt(this.total) / parseInt(this.count)
					);
					const element = document.getElementById("eval-group-table");
					element.scrollTo({
						top: 0,
						behavior: "smooth",
					});
					for (let i in this.groups) {
						if (this.groups[i].config) {
							this.groups[i].configured = true;
						} else {
							this.groups[i].configured = false;
						}
					}
					this.checkSelectAll();
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		checkSelectAll() {
			let isSelectedAll = true;
			if (this.groups.length == 0) {
				isSelectedAll = false;
			} else {
				for (let i of this.groups) {
					let record = i;
					if (
						this.selectedGroupDel.filter((value) => value == record.groupID)
							.length === 0
					) {
						isSelectedAll = false;
					}
				}
			}

			this.selectall = isSelectedAll;
		},
		resetvalues() {
			this.$v.$reset();
			this.addIndividualMail = "";
			this.editIndividualEmail = "";
			this.addIndividualEmail = "";
			this.grpcontainer = false;
			this.emailSelectedEmpty = false;
			this.groupLengthError = false;
			this.individualCandidate = "";
			this.mailids = false;
			this.mailidsearch = "";
		},
		modalpop() {
			this.filtermodalshow = true;
		},
		filter() {
			this.currentPage = 1;
			this.filtercount = 0;
			if (this.candidateType != "") {
				this.filtercount++;
			}
			this.getShareGroupData();
			this.filtermodalshow = false;
		},
		clearfilter() {
			this.currentPage = 1;
			this.filtermodalshow = false;
			this.candidateType = "";
			if (this.filtercount != 0) {
				this.getShareGroupData();
			}
			this.filtercount = 0;
		},
		sort(data) {
			this.sortColumn = data;
			this.sortOrder = !this.sortOrder;
			this.getShareGroupData();
		},
		async saveIndividual() {
			this.$v.addIndividualMail.$touch();
			try {
				if (this.$v.addIndividualMail.$error) {
					this.errorToast("Please enter Email-id");
				} else if (!this.$v.addIndividualMail.$invalid) {
					let candidates = [];
					candidates.push(this.addIndividualMail);
					let payload = {
						portion: "Group",
						name: this.addIndividualMail,
						testID: this.$route.query.testID,
						topicID: this.$route.query.topicID,
						groupType: "I",
						candidates: candidates,
					};
					const res = await postShareGroup(payload);
					if (res.status == 200) {
						this.getShareGroupData();
						this.successToast("Individual email added successfully");
						this.resetvalues();
					}
					if (res.status == 409) {
						this.errorToast(res.data.data.Data);
					}
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async addIndividual() {
			this.grptype = "individual";
			this.grpcontainer = true;
			let data = {
				tag: 0,
				groupType: "I",
			};
			const res = await taggedGroup(data);
			if (res.status == 200) {
				this.individualemials = res.data.data;
			}
			this.getShareGroupData();
		},
		async opengrpcontainer() {
			this.editIndividualEmail = "";
			this.addIndividualEmail = "";
			this.resetvalues();
			this.grpcontainer = true;
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.grptype = "create";
			let data1 = {
				tag: 0,
				groupType: "I",
			};
			const res2 = await taggedGroup(data1);
			if (res2.status == 200) {
				this.options = res2.data.data;
			}
		},
		cancelIndividualCandidate() {
			this.sectionmodal = false;
			this.individualCandidate = "";
			this.addIndividualMail = "";
			this.grpcontainer = false;
			this.resetvalues();
		},
		createGroupOpen() {
			this.selectedGroup = {};
			this.sectionmodal = false;
			this.editIndividualEmail = "";
			this.addIndividualEmail = "";
		},
		async editPerticularGroup(group) {
			this.resetvalues();
			this.grpcontainer = true;
			if (group.candidateType == "G" || group.candidateType == "R") {
				this.selectedGroup = JSON.parse(JSON.stringify(group));
				console.log("this.selectedGroup", this.selectedGroup);
				this.editIndividual = false;
				let data1 = {
					tag: 0,
					groupType: "I",
				};
				const res2 = await taggedGroup(data1);
				if (res2.status == 200) {
					this.options = res2.data.data;
				}
			} else {
				this.selectedGroup = { ...group };

				this.individualCandidate = group.groupName;
				this.editIndividual = true;
			}
			this.grptype = "edit";
		},
		viewParticularGroup(group) {
			this.groups.forEach((object) => {
				object.view = false;
			});
			group.view = true;
			this.$forceUpdate();
			this.resetvalues();
			this.grpcontainer = true;
			this.selectedGroup = group;

			this.grptype = "view";
			this.newID = group.groupID;
			this.getTaggedtest();
		},
		unView(group) {
			group.view = false;

			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.$forceUpdate();
			this.grpcontainer = false;
		},
		cancelThis() {
			this.groups.forEach((object) => {
				object.view = false;
			});
			this.$forceUpdate();
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.resetvalues();
			this.grpcontainer = false;
		},
		cancelEdit() {
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.resetvalues();
			this.grpcontainer = false;
		},
		async updateIndividual() {
			this.$v.individualCandidate.$touch();
			try {
				if (!this.$v.individualCandidate.$invalid) {
					let candidates = [];
					candidates.push(this.individualCandidate);
					let payload = {
						portion: "Group",
						groupName: this.individualCandidate,
						groupID: this.selectedGroup.groupID,
						testID: this.$route.query.testID,
						topicID: this.$route.query.topicID,
						groupType: "I",
						candidates: candidates,
					};
					const res = await putShareGroup(payload);
					if (res.status == 200) {
						this.getShareGroupData();
						this.successToast("Individual email updated successfully");
						this.resetvalues();
						this.selectedGroup = {
							groupName: "",
							candidates: [],
						};
					}
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		async createGroup() {
			this.$v.selectedGroup.groupName.$touch();
			try {
				if (this.selectedGroup.candidates.length == 0) {
					this.emailSelectedEmpty = true;
				} else if (this.selectedGroup.candidates.length < 2) {
					this.groupLengthError = true;
					this.emailSelectedEmpty = false;
				} else {
					this.groupLengthError = false;
					this.emailSelectedEmpty = false;
				}
				if (this.$v.selectedGroup.groupName.$error) {
					this.errorToast("Please enter all the details");
				} else if (!this.groupLengthError && !this.emailSelectedEmpty) {
					if (!this.$v.selectedGroup.groupName.$invalid) {
						let payload = {
							portion: "Group",
							name: this.selectedGroup.groupName,
							groupType: "G",
							candidates: this.selectedGroup.candidates,
						};
						const res = await postShareGroup(payload);
						if (res.status == 200) {
							this.successToast("Group created successfully");
							this.candidateType = "G";
							this.grpcontainer = false;
							this.getShareGroupData();
						}
						if (res.status == 409) {
							console.log(res.data.data.Data);
							this.successToast(`${res.data.data.Data}`);
						}
					}
				}
			} catch (error) {
				this.errorToast("Something went wrong");
			}
		},
		async updateGroup() {
			this.$v.selectedGroup.$touch();
			if (this.selectedGroup.candidates.length == 0) {
				this.emailSelectedEmpty = true;
				this.groupLengthError = true;
			} else if (this.selectedGroup.candidates.length < 2) {
				this.groupLengthError = true;
				this.emailSelectedEmpty = false;
			} else {
				this.groupLengthError = false;
				this.emailSelectedEmpty = false;
			}
			try {
				if (!this.$v.selectedGroup.$invalid && !this.groupLengthError) {
					let payload = {
						groupName: this.selectedGroup.groupName,
						candidates: this.selectedGroup.candidates,
						groupID: this.selectedGroup.groupID,
						testID: this.$route.query.testID,
						topicID: this.$route.query.topicID,
						groupType: this.selectedGroup.candidateType,
						check: this.check,
					};
					const res = await putShareGroup(payload);
					if (res.status == 200) {
						this.successToast("Group updated successfully");
						this.getShareGroupData();
						this.grpcontainer = false;
						this.check = true;
						this.selectedGroup = {
							groupName: "",
							candidates: [],
						};
					} else if (res.status == 409) {
						this.$bvModal.show("confirm-edit");
					} else if (res.status == 208) {
						this.errorToast(res.data.data.Details);
					}
				}
			} catch (error) {
				this.errorToast(error.response.data.data.Data);
			}
		},
		confirm() {
			this.check = false;
			this.updateGroup();
			this.$bvModal.hide("confirm-edit");
		},
		cancel() {
			this.check = true;
			this.$bvModal.hide("confirm-edit");
			this.groups.forEach((object) => {
				object.view = false;
			});
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.$forceUpdate();
			this.getShareGroupData();
		},
		removeSelectedEmail(index) {
			this.selectedGroup.candidates.splice(index, 1);
			if (this.selectedGroup.candidates.length == 0) {
				this.emailSelectedEmpty = true;
			} else {
				this.emailSelectedEmpty = false;
			}
		},
		async addSelectedGroup() {
			try {
				let payload = {
					testID: this.$route.query.testID,
					groupID: this.newID,
				};
				const res = await putShareGroup(payload);
				if (res.status == 200) {
					this.successToast("Group added successfully");
					this.getShareGroupData();
					this.grpcontainer = false;
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async generatelink(data) {
			try {
				let payload = {
					testID: this.$route.query.testID,
					groupID: data,
				};
				const res = await generateLink(payload);
				if (res.status == 200) {
					this.getShareGroupData();
					this.successToast("Link generated successfully");
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async shareLink(data) {
			try {
				let payload = {
					testID: this.$route.query.testID,
					groupID: data,
				};
				const res = await shareLink(payload);
				if (res.status == 200) {
					this.successToast("Link shared sucessfully");
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		// selectAll() {
		//   this.selectedGroupDel = [];
		//   if (this.selectall) {
		//     for (var i in this.groups) {
		//       this.selectedGroupDel.push(this.groups[i].groupID);
		//     }
		//   } else {
		//     this.selectedGroupDel = [];
		//   }
		// },
		selectAll() {
			this.selectedDataType = this.candidateType;
			if (this.selectall) {
				for (let i in this.groups) {
					if (
						this.selectedGroupDel.filter(
							(value) => value == this.groups[i].groupID
						).length === 0
					) {
						this.selectedGroupDel.push(this.groups[i].groupID);
					}
				}
			} else {
				for (let j in this.groups) {
					if (
						this.selectedGroupDel.filter(
							(value) => value == this.groups[j].groupID
						).length > 0
					) {
						this.selectedGroupDel.splice(
							this.selectedGroupDel.indexOf(this.groups[j].groupID),
							1
						);
					}
				}
			}
		},
		deselect() {
			this.selectall = false;
			const containsAll = this.groups.every((element) => {
				return this.selectedGroupDel.includes(element.groupID);
			});
			if (containsAll) {
				this.selectall = true;
			}
			this.selectedDataType = this.candidateType;
		},
		// deselect() {
		//   this.selectall = false;
		//   if (this.selectedGroupDel.length == this.groups.length) {
		//     this.selectall = true;
		//   }
		// },
		checkGroup() {
			// to check if the user have access to delete the selected data
			let values = [];
			this.groups.map((obj) => {
				if (this.selectedGroupDel.includes(obj.groupID)) {
					values.push(obj.candidateType);
				}
			});
			if (
				(values.includes("G") || values.includes("R")) &&
				!this.roles.includes("DELETE_GROUP")
			) {
				return false;
			} else if (
				values.includes("I") &&
				!this.roles.includes("DELETE_INDIVIDUAL")
			) {
				return false;
			} else {
				return true;
			}
		},
		async deleteGroup() {
			// checking access of user
			if (!this.checkGroup()) {
				this.errorToast("You don't have access to perform this action!");
				this.$bvModal.hide("modal-delete");
				this.selectedGroupDel = [];
				this.selectall = false;
			} else {
				try {
					let payload = {
						groupID: this.selectedGroupDel,
					};
					const res = await deleteShareGroup(payload);
					if (res.status == 200) {
						this.selectedGroupDel = [];
						this.getShareGroupData();
						this.successToast(this.pageTitle + " deleted successfully");
					} else if (res.status == 409) {
						this.errorToast(
							"The selected " + this.pageTitle + " is tagged to some test."
						);
					} else {
						this.errorToast("Something went wrong");
					}
					this.$bvModal.hide("modal-delete");
				} catch (error) {
					this.selectedGroupDel = [];
					this.errorToast("Something went wrong");
					this.$bvModal.hide("modal-delete");
					throw new Error(`Failed! Status:${error.status}`);
				}
			}
		},
	},
};
</script>
<style>
.btn-secondary.disabled {
	background-color: #72738e;
}
.delete-sec-btn {
	background-color: #72738e;
}
.Group-Individual-form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.375rem 0.75rem;
	font-size: 12px;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
}

.grp-sec-modal {
	position: absolute;
	width: 100%;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	padding: 15px;
	z-index: 6;
}

.twobtns {
	position: absolute;
	bottom: 10px;
	right: 20px;
}

.sharemailbtns .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
	color: #696969;
	background-color: #f4f4f4;
	border-color: #f4f4f4;

	width: 100%;
	text-align: start;
}

.sharemailbtns .btn-secondary {
	color: #696969;
	background-color: #ffffff;
	border-color: #ffffff;
}

.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}

.slectedcandidate-table-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 155px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 100%;
}

.grp-right-container {
	position: absolute;
	width: 450px;
	height: calc(100vh - 101px);
	right: 5px;
	top: -16px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

.slectedcandidate-table-container-seventy {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 155px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 70%;
}

.grouptable tbody {
	display: block;
	border-radius: 5px;
	overflow: auto;
	height: calc(100vh - 315px);
	margin-top: 5px;
	width: calc(100% - 5px);
}

.grp-reports-table thead tr {
	height: 45px;
	background: #e3e4e4;
	border-radius: 3px;
	vertical-align: middle;
	display: table;
	width: 100%;
	table-layout: fixed;
}

.grp-reports-table thead th {
	font-weight: 500 !important;
	font-size: 14px;
	color: #72738e;
}

.grp-reports-table thead th:last-child {
	padding-right: 15px;
}

.grp-reports-table tbody td {
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #696969;
	overflow: hidden;
	text-overflow: ellipsis;
}

.grp-reports-table tbody td:first-child {
	position: relative;
}

.grp-reports-table tbody td:last-child {
	padding-right: 20px;
}

.grp-reports-table tbody tr {
	height: 60px;
	cursor: pointer;
	box-sizing: border-box;
	box-shadow: 0px 4px 12px rgb(196 196 196 / 50%);
	margin: 10px 5px 8px 5px;
	width: calc(100% - 10px);
	display: table;
	border-radius: 3px;
	table-layout: fixed;
}

.shareppl-parentdiv {
	position: relative;
	height: calc(100vh - 90px);
	top: 80px;
	padding-left: 80px;
	overflow-x: hidden;
	padding-right: 15px;
}

.selected-table-cards:hover {
	background: #e7e8f5;
}

.grp-searchbox {
	position: relative;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
}

.groupshare-formtag {
	border: none;
	padding: 0px;
}

.groupshare-seachinput {
	padding: 0.5rem 2rem !important;
}

.sharelink-elipsis {
	width: 356px;
	height: 20px;
	overflow: hidden;
	display: -webkit-box !important;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	white-space: normal;
	border: none;
	background: none !important;
}

.sharelink-elipsis-show {
	width: 400px;
	height: 20px;
	overflow: hidden;
	display: -webkit-box !important;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	white-space: normal;
	border: none;
}

.groupOptionsDiv {
	height: 200px;
	overflow-y: auto;
}

.group-filter-modal {
	position: absolute;
	width: 350px;
	height: 150px;
	top: 110px;
	right: 75px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.addtaginput {
	margin-left: -38px;
	margin-top: -7px;
}

.input-group > .form-control:focus {
	z-index: inherit;
}

.qb-filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 8px;
	position: absolute;
	right: 60px;
}

.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
}

.grp-indiv-mail {
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: 0px 0px 5px rgba(86, 86, 86, 0.2);
	border-radius: 5px;
}

.grp-main-head {
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
}

.grp-mail-link {
	font-weight: 600;
	font-size: 13px;
	color: #696969;
}

.grp-tagged-test-card {
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: 0px 0px 5px rgba(86, 86, 86, 0.2);
	border-radius: 5px;
}

.grp-test-subhead {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.grp-test-head {
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}

.grp-evalute-asmnt-text {
	font-weight: 400;
	font-size: 12px;
	color: #696969;
}

.grp-green-text {
	font-weight: 500;
	font-size: 14px;
	color: #038e00;
}

.grp-blue-text {
	font-weight: 500;
	font-size: 14px;
	color: #5782ff;
}

.grp-yellow-text {
	font-weight: 500;
	font-size: 14px;
	color: #ffc145;
}

.grp-tagged-test-head {
	font-weight: 500;
	font-size: 12px;
	color: #72738e;
}

.grp-tagged-test-overflow-1 {
	overflow: auto;
	height: calc(100vh - 640px);
}

.grp-tagged-test-overflow-2 {
	overflow: auto;
	height: auto;
}

.get-tagged-individual {
	min-height: 50px;
	max-height: calc(100vh - 380px);
	overflow: auto;
}

.grp-search-candidate {
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: 0px 0px 5px rgba(86, 86, 86, 0.2);
	border-radius: 5px;
}

.grp-edit-search-candidate {
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: 0px 0px 5px rgba(86, 86, 86, 0.2);
	border-radius: 5px;
	height: calc(100vh - 290px);
}

.grp-second-section {
	display: flex;
	align-items: center;
	border-top: 1px solid #e2e2e2;
	border-bottom: 1px solid rgba(114, 115, 142, 0.4);
}

.grp-search-bar-search {
	display: flex;
}

.grp-search-bar-searchicon {
	position: relative;
	color: #a2a2a2;
}

.grp-search-bar-searchbtn {
	position: relative;
	border: none;
	border-radius: 0;
	background-color: transparent;
}

.grp-search-bar-searchbtn:focus {
	background-color: transparent;
	box-shadow: 0 0 0 0;
}

.grp-candidates-overflow {
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 663px);
}

.grp-edit-candidates-overflow {
	height: 320px;
	overflow: auto;
}

.grp-groupOptionsDivUpadte {
	height: 150px;
	overflow: auto;
}

.grp-jdTypeCheck:nth-child(odd) {
	background: #f4f4f4;
}

.grp-jdTypeCheck:nth-child(even) {
	background: #fdfdfd;
}

.grp-twobtns {
	position: absolute;
	bottom: 15px;
	right: 10px;
}
.grp-twobtns-2 {
	position: absolute;
	bottom: 0px;
	right: 0px;
}
.grp-right-container .topDiv > .inputField {
	border: 1px solid var(--input-border);
	padding: 8px;
	border-radius: 3px !important;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	line-height: 18px;
	z-index: 5;
	background: var(--bg-inputfield);
}

.grp-group-detail-footer {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 0px 0px 10px 10px;
	width: 100%;
	z-index: 1000;
}

.grp-check-email {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
}

.grp-checkboxcontainer {
	height: 200px;
	overflow: auto;
}

.grp-total-test-text {
	font-weight: 400;
	font-size: 12px;
	color: #72738e;
}

.group-slectedcandidate-table-container-seventy {
	background: #ffffff;
	border-radius: 8px;
	padding: 15px;
	height: calc(100vh - 145px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 70%;
}

.GI-qb-dropdown-option-add {
	background: #ffffff;
	border: 0.5px solid rgba(10, 86, 200, 0.5);
	box-sizing: border-box;
	position: absolute;
	z-index: 7;
	width: 100%;
	border-radius: 3px;
	font-size: var(--size-13);
	color: #545454;
	cursor: pointer;
}

.GI-checkboxcontainer {
	min-height: auto;
	max-height: 200px;
	overflow-y: auto;
	overflow-x: hidden;
}

.GI-checkboxcontainer-edit {
	min-height: auto;
	max-height: calc(100vh - 475px);
	overflow-y: auto;
	overflow-x: hidden;
}

.swp-jdTypeCheck:nth-child(odd) {
	background: #f4f4f4;
}

.swp-jdTypeCheck:nth-child(even) {
	background: #fdfdfd;
}

.GI-card-height-create-g {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin: 3px;
}

.swp-main-text {
	font-weight: 600;
	font-size: 14px;
	color: #696969;
}

.GI-cancelbtntext {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 6px 20px;
}

.create-group-content {
	overflow-y: auto;
	overflow-x: hidden;
	min-height: 40px;
	max-height: calc(100vh - 485px);
}

.Edit-group-content {
	overflow-x: hidden;
	overflow-y: auto;
	min-height: 40px;
	max-height: calc(100vh - 590px);
}

.groupContainer-change-class {
	position: absolute;
	width: 350px;
	height: 150px;
	top: 110px;
	right: 30%;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.newGroupDiv .form-control.error:focus {
	border: 1px solid red !important;
	font-size: 12px !important;
}

.grp-tab {
	color: #72738e;
	font-size: 14px;
	font-weight: 500;
	background-color: #ececec;
	height: 37px;
	width: 200px;
	border-radius: 2px;
}

.grp-slant {
	top: 0px;
	right: -18px;
	position: absolute;
	width: 40px;
	height: 38px;
	background-color: #ececec;
	transform: skew(40deg);
}

.grp-tab-sel {
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	background-color: #72738e;
	height: 37px;
	width: 200px;
	border-radius: 2px;
}
.grp-slant-sel {
	top: 0px;
	right: -18px;
	position: absolute;
	width: 40px;
	height: 38px;
	background-color: #72738e;
	transform: skew(40deg);
}

.grp-mr {
	margin-right: 32px;
}

.slide-leave-active,
.slide-enter-active {
	transition: 0.5s;
}
.slide-enter {
	transform: translate(100%, 0);
}
.slide-leave-to {
	transform: translate(100%, 0);
}

/* table new design starts from here */
.group-slectedcandidate-table-container {
	background: #ffffff;
	border-radius: 8px;
	padding: 15px;
	height: calc(100vh - 145px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 100%;
}

.group-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 216px);
	overflow-x: auto;
	overflow-y: hidden;
}

.group-table-head {
	min-width: 1000px;
	max-width: 100%;
	background: #e3e4e4;
	border-radius: 3px;
	display: flex;
	align-items: center;
	padding: 10px 0px;
	font-weight: 500 !important;
	font-size: 14px;
	color: #72738e;
}

.group-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 306px);
}

.group-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 2px solid #e5e5e5;
	background: #fafafa;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 6px 0px;
}

.group-table-row:hover {
	background: #e7e8f5;
}

.group-changecolor-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	background: #ebf5fe;
	border: 2px solid #84bae7;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 6px 0px;
}

.group-check-width {
	width: 5%;
}

.group-name-width {
	width: 35%;
}

.group-cand-width {
	width: 15%;
}

.group-delete-icon-width {
	width: 10%;
}

.paginaTion {
	min-width: 1002px;
	max-width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}
</style>
